module.exports = __webpack_public_path__ + "static/media/4_graph_3.f697affd.svg";